import { render, staticRenderFns } from "./concierge-table.html?vue&type=template&id=58a20d52&scoped=true&"
import script from "./concierge-table.js?vue&type=script&lang=js&"
export * from "./concierge-table.js?vue&type=script&lang=js&"
import style0 from "./concierge-table.scss?vue&type=style&index=0&id=58a20d52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a20d52",
  null
  
)

export default component.exports